<template>
  <WTooltip v-if="iconOnly" :label="assessmentName">
    <div :class="['icon', assessmentClassName]">
      <WIcon icon="icSorting" />
    </div>
  </WTooltip>

  <div v-else :class="['assessment', assessmentClassName]">
    <WIcon icon="icSorting" />
    <WParagraph>{{ assessmentName }}</WParagraph>
    <slot />
  </div>
</template>

<script>
import { WIcon, WParagraph, WTooltip } from '@alice-health/wonderland-vue'

import { AssessmentNames } from '@/models/channels'

export default {
  name: 'CAssessmentIcon',
  components: { WIcon, WTooltip, WParagraph },
  props: {
    assessment: {
      type: String,
      required: true
    },
    iconOnly: Boolean
  },
  computed: {
    assessmentName() {
      return AssessmentNames[this.assessment]
    },
    assessmentClassName() {
      return this.assessment.toLowerCase()
    }
  }
}
</script>

<style lang="scss" scoped>
.assessment {
  font-size: var(--gl-font-size-xxxs);
  align-items: center;
  color: var(--gl-color-shades-gray-60);
  display: flex;
  font-weight: --gl-font-weight-regular;
  gap: var(--gl-spacing-02);
  letter-spacing: var(--gl-letter-spacing-rule-02);
}

.emergency {
  color: var(--gl-color-shades-magenta-80);
}

.emergency_suspect {
  color: var(--sys-color-surface-container-error);
}

.urgency {
  color: var(--gl-color-shades-yellow-40);
}

.relative_urgency {
  color: var(--sys-color-surface-container-success);
}

.indirect_health {
  color: var(--gl-color-shades-blue-20);
}

.icon {
  margin-right: var(--gl-spacing-02);
}
</style>
